<template>
    <div>
        <NetworkStatus/>
        <Navbar v-bind:hideMenu="true" />

        <div class="section section-color center">
            <div class="w-container">
                <div class="key-number" style="padding-top: 0">{{$t('sign_up')}}</div>
            </div>
        </div>

        <div class="page-content top-spacer-30">
            <form id="signupForm" class="form">
                <b-field grouped>
                    <b-field :label="$t('first_name') + ' *'" style="width:48%">
                        <b-input v-model="form.first_name" type="text" autocomplete="given-name" required></b-input>
                    </b-field>

                    <b-field :label="$t('last_name') + ' *'" style="width:48%">
                        <b-input v-model="form.last_name" type="text" autocomplete="family-name" required></b-input>
                    </b-field>
                </b-field>

                <b-field :label="$t('email_address') + ' *'">
                    <b-input v-model="form.email_address" type="email" autocomplete="email" required></b-input>
                </b-field>

                <b-field :label="$t('company') + ' *'">
                    <b-input v-model="form.company" type="text" autocomplete="organization" required></b-input>
                </b-field>

                <b-field :label="$t('country') + ' *'" style="margin-bottom: 1em">
                    <b-select v-model="form.country_code" required>
                        <option v-for="country in countries"
                                :key="country.country_code"
                                :value="country.country_code"
                                :selected="country.country_code === form.country_code">
                            {{country.country_name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field :type="{'is-danger': passwordInvalid}" :message="{'Passwords need to be at least 8 characters long, contain an upper and lowercase character, and have at least one number or special character': passwordInvalid }">

                    <template v-slot:label>
                        {{$t('password')}} *
                    </template>
                    <b-input v-model="form.password" type="password" v-on:blur="validatePasswordRules" password-reveal required></b-input>
                </b-field>

                <b-field :label="$t('repeat-password') + ' *'">
                    <b-input v-model="form.password2" type="password" password-reveal required></b-input>
                </b-field>

                <b-field :label="$t('how_did_you_hear') + ' *'" style="margin-bottom: 1em">
                    <b-select v-model="form.referrer" required>
                        <option v-for="referrer in referrers"
                                :key="referrer"
                                :value="referrer"
                                :selected="referrer === referrer">
                            {{referrer}}
                        </option>
                    </b-select>
                </b-field>

                <b-field v-if="form.referrer === 'Referral'">
                    <template v-slot:label>
                        <div>{{$t('referral_name')}}</div>
                        <div style="font-size:14px;font-weight: normal">{{$t('referral_name_tooltip')}}</div>
                    </template>
                    <b-input v-model="form.referral_name" type="text" maxlength="250"></b-input>
                </b-field>

                <b-field>
                    <b-checkbox v-model="form.agree" :value="true"></b-checkbox>
                    <span> {{$t('i_agree_to_the')}} <a href="terms.html" target="_blank">{{$t('terms')}}</a> {{$t('and')}} <a href="https://www.sift.co/privacy" target="_blank">{{$t('privacy_policy')}}</a></span>
                </b-field>

                <ErrorMessages :errors="errors"></ErrorMessages>
            </form>

            <div class="button-group">
                <button class="left ds-button button-small w-button" v-on:click="submit">
                    {{$t('create_account')}}
                </button>
                <div class="right font-normal">
                    {{$t('have_an_account')}} <a href="login.html">{{$t('log_in')}}</a>
                </div>
            </div>
        </div>

        <Footer/>

    </div>
</template>

<style>
.page-content {
    padding-top: 20px;
}
.field {
    margin-bottom: 0;
}
.field:not(:last-child) {
    margin-bottom: 0;
}
.header-text p {
    color: #636081;
}
.button-group {
    padding-left: 20px;
    padding-top: 30px;
    padding-bottom: 30px;
    max-width: 550px;
    margin: auto;
    width: 100%;
    display: flex;
    font-weight: bold;
    font-size: 18px;
    justify-content: space-between;
}
.left {
    width: auto;
    text-align: left;
}
.right {
    width: 50%;
    text-align: right;
    margin-right: 25px;
}
.top-spacer-30 {
    margin-top: 30px;
}
.form {
    padding-left: 20px;
    padding-right: 20px;
    max-width: 550px;
    margin: auto;
}
.field, .control {
    text-align: left;
}
.label {
    color: #363636;
    background-color: #fff;
    text-align: left;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
    display: block;
    font-size: 1rem;
    font-weight: 700;
}
@media (max-width: 479px) {
    .page-content {
        margin: 0 20px 0 20px;
        width: 350px;
    }
}
</style>

<script>
import Navbar from "../components/Navbar";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import ErrorMessages from "../components/ErrorMessages";
import session from '../session'

function successHandler() {
    session.navigateToPage('manage_ads.html');
}

function errorHandler() {
}

const model = {
    countries: [],
    form: {
        first_name: null,
        last_name: null,
        email_address: null,
        company: null,
        country_code: null,
        password: null,
        password2: null,
        referrer: null,
        referral_name: null
    },
    referrers: [
        "Google search",
        "Ad on website or app",
        "Email",
        "Referral",
        "Other"
    ],
    is_robot: true,
    errors: [],
    passwordInvalid: false
};

function getCountriesSuccessHandler(responseData) {
    model.form.country_code = responseData.ip_country_code;
    model.countries = responseData.countries
}

function getCountriesErrorHandler() {
    model.form.country_code = "US";
    model.countries = [
        {
            country_code: "US",
            country_name: "United States"
        }
    ];
}

session.get('countries', getCountriesSuccessHandler, getCountriesErrorHandler, model.errors);

function validate() {
    model.errors.splice(0, model.errors.length);
    const passwordOK = model.form.password === model.form.password2;
    if (!passwordOK) {
        model.errors.push('PASSWORDS_DO_NOT_MATCH');
    }
    if (!model.form.agree) {
        model.errors.push('MUST_AGREE');
    }
    const valid = document.getElementById('signupForm').checkValidity();
    if (!valid) {
        model.errors.push('ALL_FIELDS_ARE_REQUIRED');
    }
    return model.errors.length === 0 && model.passwordInvalid === false;
}

export default {
    components: {
        Navbar, NetworkStatus, Footer, ErrorMessages //, VueRecaptcha
    },

    data() {
        return model;
    },

    methods: {
        validatePasswordRules: function () {
            const lower = /.*[a-z]+.*$/;
            const upper = /.*[A-Z]+.*$/;
            const other = /.*[^a-zA-Z]+.*$/;
            model.passwordInvalid = !(model.form.password.length >= 8 && model.form.password.match(lower) && model.form.password.match(upper) && model.form.password.match(other));
        },
        submit: function () {
            if (validate()) {
                session.signup(model.form, successHandler, errorHandler, model.errors)
            }
        },
        /*
                onVerify: function (response) {
                    if (response && validate()) {
                        model.form.recaptcha_token = response;
                        session.signup(model.form, successHandler, errorHandler, model.errors)
                    }
                },
                onExpired: function () {
                    model.form.recaptcha_token = null;
                    this.$refs.recaptcha.reset();
                }
        */
    }
}
</script>